/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MousePointerClick = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m9 9 5 12 1.8-5.2L21 14Z" }],
    ["path", { d: "M7.2 2.2 8 5.1" }],
    ["path", { d: "m5.1 8-2.9-.8" }],
    ["path", { d: "M14 4.1 12 6" }],
    ["path", { d: "m6 12-1.9 2" }]
  ]
];

export { MousePointerClick as default };
//# sourceMappingURL=mouse-pointer-click.js.map
